module.exports = __webpack_public_path__ + "media/images/flags/es-ct-1796893df41886541c9fe7c91236e5e9.svg";